var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBleat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 833.59 958.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 241.61,
    width: 833.59,
    height: 716.89,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.02,142.86c-8.31,0-15.71-1.83-22.19-5.5-6.48-3.67-11.61-9.17-15.4-16.5-3.67-7.46-5.5-16.87-5.5-28.24s1.89-20.91,5.68-28.24c3.91-7.34,9.11-12.78,15.59-16.32,6.6-3.67,13.88-5.5,21.82-5.5,9.66,0,18.15,2.08,25.49,6.24,7.46,4.16,13.33,9.96,17.61,17.42,4.4,7.46,6.6,16.26,6.6,26.41s-2.2,18.95-6.6,26.41c-4.28,7.46-10.15,13.33-17.61,17.61-7.34,4.16-15.83,6.24-25.49,6.24Zm-54.28-1.28V5.5h22.92v60.89l-1.83,26.04,.73,26.04v23.11h-21.82Zm51.72-18.34c5.5,0,10.39-1.22,14.67-3.67,4.4-2.44,7.89-5.99,10.45-10.64,2.57-4.65,3.85-10.09,3.85-16.32s-1.28-11.8-3.85-16.32c-2.57-4.65-6.05-8.19-10.45-10.64-4.28-2.45-9.17-3.67-14.67-3.67s-10.45,1.22-14.85,3.67c-4.4,2.45-7.89,5.99-10.45,10.64-2.57,4.52-3.85,9.96-3.85,16.32s1.28,11.68,3.85,16.32c2.57,4.65,6.05,8.19,10.45,10.64,4.4,2.44,9.35,3.67,14.85,3.67Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9,142.86c-8.31,0-15.65-1.53-22.01-4.58-6.36-3.18-11.31-7.95-14.85-14.31-3.55-6.48-5.32-14.61-5.32-24.39V43.65h22.92v52.82c0,8.8,1.96,15.41,5.87,19.81,4.03,4.28,9.72,6.42,17.05,6.42,5.38,0,10.02-1.1,13.94-3.3,4.03-2.2,7.15-5.5,9.35-9.9,2.32-4.4,3.48-9.84,3.48-16.32V43.65h22.92v97.93h-21.82v-26.41l3.85,8.07c-3.3,6.36-8.13,11.25-14.49,14.67-6.36,3.3-13.33,4.95-20.91,4.95Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.29,141.58V43.65h22.92v97.93h-22.92Zm11.55-114.07c-4.28,0-7.82-1.34-10.64-4.03-2.69-2.69-4.04-5.93-4.04-9.72s1.35-7.15,4.04-9.72c2.81-2.69,6.36-4.03,10.64-4.03s7.76,1.28,10.45,3.85c2.81,2.45,4.22,5.56,4.22,9.35,0,4.03-1.35,7.46-4.03,10.27-2.69,2.69-6.24,4.03-10.64,4.03Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.3,141.58V5.5h22.92V141.58h-22.92Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.01,142.86c-10.76,0-19.07-2.75-24.94-8.25-5.87-5.62-8.8-13.88-8.8-24.76V22.01h22.92V109.3c0,4.65,1.16,8.25,3.48,10.82,2.45,2.57,5.81,3.85,10.09,3.85,5.14,0,9.41-1.35,12.84-4.03l6.42,16.32c-2.69,2.2-5.99,3.85-9.9,4.95-3.91,1.1-7.95,1.65-12.1,1.65Zm-49.88-80.14v-18.34h65.29v18.34h-65.29Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.84,142.86c-8.31,0-15.71-1.83-22.19-5.5-6.48-3.67-11.61-9.17-15.41-16.5-3.67-7.46-5.5-16.87-5.5-28.24s1.9-20.91,5.69-28.24c3.91-7.34,9.11-12.78,15.59-16.32,6.6-3.67,13.88-5.5,21.82-5.5,9.66,0,18.16,2.08,25.49,6.24,7.46,4.16,13.33,9.96,17.61,17.42,4.4,7.46,6.6,16.26,6.6,26.41s-2.2,18.95-6.6,26.41c-4.28,7.46-10.15,13.33-17.61,17.61-7.33,4.16-15.83,6.24-25.49,6.24Zm-54.28-1.28V5.5h22.92v60.89l-1.83,26.04,.73,26.04v23.11h-21.82Zm51.72-18.34c5.5,0,10.39-1.22,14.67-3.67,4.4-2.44,7.88-5.99,10.45-10.64,2.57-4.65,3.85-10.09,3.85-16.32s-1.28-11.8-3.85-16.32c-2.57-4.65-6.05-8.19-10.45-10.64-4.28-2.45-9.17-3.67-14.67-3.67s-10.45,1.22-14.85,3.67c-4.4,2.45-7.89,5.99-10.45,10.64-2.57,4.52-3.85,9.96-3.85,16.32s1.28,11.68,3.85,16.32c2.57,4.65,6.05,8.19,10.45,10.64s9.35,3.67,14.85,3.67Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.66,178.44c-4.77,0-9.54-.79-14.3-2.38-4.77-1.59-8.74-3.79-11.92-6.6l9.17-16.87c2.32,2.08,4.95,3.73,7.89,4.95,2.93,1.22,5.93,1.83,8.99,1.83,4.16,0,7.52-1.04,10.09-3.12,2.57-2.08,4.95-5.56,7.15-10.45l5.68-12.84,1.83-2.75,37.04-86.56h22.01l-45.85,105.82c-3.06,7.34-6.48,13.14-10.27,17.42-3.67,4.28-7.82,7.27-12.47,8.99-4.52,1.71-9.54,2.57-15.04,2.57Zm20.17-33.38l-44.2-101.41h23.84l35.94,84.54-15.59,16.87Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy",
    d: "M420.08,951.22c225.31,0,407.98-155.48,407.98-347.15s-182.67-347.15-407.98-347.15S12.1,412.39,12.1,604.07c0,92.26,31.06,164.48,100.16,226.6,25.18,22.6-84.17,111.18-70.75,120.56,9.56,6.8,127.36-72.59,150.15-59.36,65.24,37.49,143.9,59.36,228.43,59.36Z",
    style: {
      fill: "#f7d54d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.4,628.7c0,42.61-28.05,61.92-65.1,61.92-15.88,0-29.9-4.76-38.64-13.5-9.53,8.2-25.93,14.03-25.93,9.79v-164.87c0-9-2.65-12.97-13.5-16.94v-4.5l46.31-9.79v95.27c8.47-15.88,28.05-22.49,40.75-22.49,29.64,0,56.1,23.29,56.1,65.1Zm-37.84,2.12c0-42.34-9.79-56.1-31.49-56.1-18,0-27.52,14.82-27.52,33.61v33.61c0,33.34,16.41,44.19,31.49,44.19,19.32,0,27.52-14.82,27.52-55.31Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.44,683.74v4.5h-54.25v-4.5c10.06-2.91,10.59-14.03,10.59-27.52v-133.9c0-9.26-2.65-13.23-13.23-17.2v-4.5l46.31-9.79v165.4c0,14.55,1.32,25.14,10.59,27.52Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.4,624.73h-84.15c2.12,25.93,15.35,39.43,33.08,43.4,14.29,3.18,35.46-2.12,42.08-14.55l4.5,2.38c-4.23,13.76-19.85,34.67-55.31,34.67s-58.48-32.02-58.48-62.98c0-37.31,25.4-64.04,61.92-64.04,38.37,0,56.37,19.85,56.37,61.13Zm-32.29-4.5c0-33.34-10.85-52.13-25.41-52.13-15.61,0-26.46,26.73-26.46,52.13h51.87Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.83,669.98l4.5,1.85c-2.12,8.47-14.29,18.79-30.96,18.79,0,0-23.55,0-26.46-21.44-3.97,11.64-19.58,21.44-38.37,21.44,0,0-30.43,0-30.43-26.99,0-28.84,22.23-31.49,68.54-43.13v-16.41c0-27.52-15.35-41.28-33.61-31.76-8.47,4.23-9.53,8.73-7.67,9,3.97,.53,7.41,2.38,9.79,5.82,4.76,6.88,2.91,16.14-3.97,20.91-6.88,4.5-16.14,2.91-20.91-3.97-3.18-5.03-3.44-11.38-.79-15.88s6.09-11.64,20.64-19.32c11.91-6.35,25.67-5.29,25.67-5.29,34.67,0,44.19,21.7,44.19,52.93v39.43s-.26,18.52,12.7,18.52c0,0,5.56,0,7.14-4.5Zm-53.19-44.72c-25.93,5.82-34.67,18.26-34.67,31.76,0,0,0,17.47,17.2,17.47,9,0,15.08-7.15,17.47-13.5v-35.73Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.78,662.57l3.97,2.38c-5.29,12.44-21.44,25.67-39.17,25.67-20.91,0-33.34-8.47-33.34-40.49v-79.65h-13.23l-.79-4.5h14.03v-35.46l33.08-5.56v41.02h31.49l-1.06,4.5h-30.43v78.86c0,14.82,6.35,22.49,19.58,22.49,7.67,0,13.5-5.29,15.88-9.26Z",
    style: {
      fill: "#1f2a44"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBleat);
export default __webpack_public_path__ + "static/media/logo-bleat.3e1f27d3a573acdbc1deee464be7d1b5.svg";
export { ForwardRef as ReactComponent };